import React, { Component } from 'react'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  Button,
  IconButton,
  Tooltip,
  TextField
} from '@material-ui/core'
import {
  EditOutlined as EditIcon,
  DeleteOutlined as DeleteIcon,
  CloudUploadOutlined as UploadIcon,
  CreateOutlined as CreateIcon
} from '@material-ui/icons'

import env from '../../config/env'
import {
  MainTitle,
  Snackbar as MySnackbar,
  TableComponent,
  DialogConfirm
} from '../../components'
import {
  fetchCommunitys,
  createCommunity,
  updateCommunity,
  deleteCommunity,
  resetCommunity
} from '../../store/actions/admin/Community'

const { uri: proxy } = env.server

const defaultInput = {
  create: {
    _id: '',
    title: '',
    source: '',
    place: '',
    year: '',
    file: ''
  },
  update: {
    _id: '',
    title: '',
    source: '',
    place: '',
    year: '',
    file: ''
  }
}

const defaultDialog = {
  delete: {
    attr: null,
    open: false
  },
  create: {
    attr: null,
    open: false
  },
  update: {
    attr: null,
    open: false
  }
}

class Community extends Component {
  constructor(props) {
    super(props)

    if (props.token === null) {
      props.history.push('/admin/login')
    }

    this.state = {
      input: defaultInput,
      dialog: defaultDialog
    }
  }

  componentDidMount() {
    this.resetError()
    this.props.fetchCommunitys()
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.Community.communitys !== nextProps.Community.communitys
      || this.props.Community.communitys.length !== nextProps.Community.communitys.length
    ) {
      this.setState({
        input: defaultInput,
        dialog: defaultDialog
      })
    }
  }

  prepareCreateCommunity = () => {
    this.toggleDialog('create')
  }

  prepareUpdateCommunity = id => {
    const { communitys } = this.props.Community
    const communityData = communitys.find(({ _id }) => _id === id)
    this.setState({
      input: {
        ...this.state.input,
        update: {
          ...communityData,
          image: ''
        }
      }
    }, () => {
      this.toggleDialog('update')
    })
  }

  prepareDeleteCommunity = id => {
    this.toggleDialog('delete', id)
  }

  createCommunity = () => {
    const { create: newCommunity } = this.state.input
    const formData = new FormData()
    formData.set('title', newCommunity.title)
    formData.set('source', newCommunity.source)
    formData.set('place', newCommunity.place)
    formData.set('year', newCommunity.year)
    formData.set('file', newCommunity.file)
    this.props.createCommunity(formData)
  }

  updateCommunity = () => {
    const { update: newCommunity } = this.state.input
    const formData = new FormData()
    formData.set('_id', newCommunity._id)
    formData.set('title', newCommunity.title)
    formData.set('source', newCommunity.source)
    formData.set('place', newCommunity.place)
    formData.set('year', newCommunity.year)
    formData.set('file', newCommunity.file)
    this.props.updateCommunity(formData)
  }

  deleteCommunity = () => {
    const { attr: id } = this.state.dialog.delete
    this.props.deleteCommunity(id)
  }

  toggleDialog = (name, attr = null) => {
    const { state } = this
    this.setState({
      dialog: {
        ...state.dialog,
        [name]: {
          ...state.dialog[name],
          attr: attr,
          open: !state.dialog[name].open
        }
      }
    })
  }

  onChangeInput = (e, name, fileInput = false) => {
    this.setState({
      input: {
        ...this.state.input,
        [name]: {
          ...this.state.input[name],
          [e.target.id]: fileInput
            ? e.target.files[0] ? e.target.files[0] : this.state.input[e.target.id]
            : e.target.value
        }
      }
    })
  }

  resetError = () => {
    this.props.resetCommunity()
  }

  render() {
    const {
      onChangeInput,
      toggleDialog,
      prepareCreateCommunity,
      prepareUpdateCommunity,
      prepareDeleteCommunity,
      createCommunity,
      updateCommunity,
      deleteCommunity
    } = this
    const { open: deleteDialog } = this.state.dialog.delete
    const { open: createDialog } = this.state.dialog.create
    const { open: updateDialog } = this.state.dialog.update

    const { input } = this.state
    const { errors, isLoading } = this.props.Community
    let { communitys } = this.props.Community
    communitys = communitys.map(community => ({
      ...community,
      file: (<Button
        color='secondary'
        variant='outlined'
        target='_blank'
        href={`${proxy}/${community.file}`}
        >{'UNDUH'}</Button>),
      actions: (
        <div className='actions'>
          <Tooltip title='Update'>
            <IconButton onClick={() => prepareUpdateCommunity(community._id)}>
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title='Delete'>
            <IconButton onClick={() => prepareDeleteCommunity(community._id)}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </div>
      )
    }))

    const schema = {
      actions: 'Aksi',
      title: 'Judul',
      source: 'Sumber',
      place: 'Tempat',
      year: 'Tahun',
      file: 'Berkas'
    }

    const title = 'Pengabdian Masyarakat'

    return (
      <div>
        <MainTitle title={title} />
        <TableComponent
          title={'Pengabdian Masyarakat'}
          data={communitys}
          schema={schema}
          expanded={true}
          loading={isLoading}
          headerNode={(
            <Tooltip title='Create'>
              <Button
                variant='outlined'
                color='secondary'
                onClick={() => prepareCreateCommunity()}>
                <CreateIcon fontSize='small'/>&nbsp;
                Tambah
              </Button>
            </Tooltip>
          )}
          />
        <DialogConfirm
          open={deleteDialog}
          title={'Hapus'}
          body={'Apakah anda yakin menghapus Pengabdian Masyarakat ini?'}
          onConfirm={() => deleteCommunity()}
          onClose={() => toggleDialog('delete')}
          />
        <DialogConfirm
          open={createDialog}
          title={'Tambah'}
          body={'Masukkan beberapa informasi Pengabdian Masyarakat anda dibawah'}
          onConfirm={() => createCommunity()}
          onClose={() => toggleDialog('create')}
          inputNode={(
            <form className='dialog-form'>
              <TextField
                id='title'
                margin='dense'
                label='Judul'
                value={input.create.title}
                onChange={e => onChangeInput(e, 'create')}
                variant='outlined'
                fullWidth
              />
              <TextField
                id='source'
                margin='dense'
                label='Sumber'
                value={input.create.source}
                onChange={e => onChangeInput(e, 'create')}
                variant='outlined'
                fullWidth
              />
              <TextField
                id='place'
                margin='dense'
                label='Tempat'
                value={input.create.place}
                onChange={e => onChangeInput(e, 'create')}
                variant='outlined'
                fullWidth
              />
              <TextField
                id='year'
                margin='normal'
                label='Tahun'
                value={input.create.year}
                onChange={e => onChangeInput(e, 'create')}
                variant='outlined'
                fullWidth
              />
            <br /><br />
            <div className='input-file'>
              <input
                id='file'
                type='file'
                style={{ display: 'none' }}
                onChange={e => onChangeInput(e, 'create', true)}
                accept='application/pdf'
                />
              <label htmlFor='file'>
                <Tooltip title='Upload file'>
                  <IconButton color='secondary' component='span'>
                    <UploadIcon />
                  </IconButton>
                </Tooltip>
              </label>
              <TextField
                disabled
                placeholder={input.create.file.name}
                fullWidth
                className='file-name-input'
                />
            </div>
            </form>
          )}
          />
        <DialogConfirm
          open={updateDialog}
          title={'Perbaruan'}
          body={'Masukkan perbaruan informasi Pengabdian Masyarakat anda dibawah'}
          onConfirm={() => updateCommunity()}
          onClose={() => toggleDialog('update')}
          inputNode={(
            <form className='dialog-form'>
              <TextField
                id='title'
                margin='dense'
                label='Judul'
                value={input.update.title}
                onChange={e => onChangeInput(e, 'update')}
                variant='outlined'
                fullWidth
              />
              <TextField
                id='source'
                margin='dense'
                label='Sumber'
                value={input.update.source}
                onChange={e => onChangeInput(e, 'update')}
                variant='outlined'
                fullWidth
              />
              <TextField
                id='place'
                margin='dense'
                label='Tempat'
                value={input.update.place}
                onChange={e => onChangeInput(e, 'update')}
                variant='outlined'
                fullWidth
              />
              <TextField
                id='year'
                margin='normal'
                label='Tahun'
                value={input.update.year}
                onChange={e => onChangeInput(e, 'update')}
                variant='outlined'
                fullWidth
              />
              <br /><br />
              <div className='input-file'>
                <input
                  id='file'
                  type='file'
                  style={{ display: 'none' }}
                  onChange={e => onChangeInput(e, 'update', true)}
                  />
                <label htmlFor='file'>
                  <Tooltip title='Upload file'>
                    <IconButton color='secondary' component='span'>
                      <UploadIcon />
                    </IconButton>
                  </Tooltip>
                </label>
                <TextField disabled placeholder={input.update.file.name} fullWidth  className='file-name-input'/>
              </div>
            </form>
          )}
          />
        <MySnackbar
          variant={'error'}
          open={errors.status}
          message={errors.message}
          handleClose={this.resetError}
          />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  token: state.Auth.token,
  Community: state.AdminCommunity
})

export default compose(
  connect(mapStateToProps, {
    fetchCommunitys,
    createCommunity,
    updateCommunity,
    deleteCommunity,
    resetCommunity
  }),
  withRouter
)(Community)
